import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Siblings.
import './styles.css';

//------------------------------------------------------------------------------

const LegendItem = ({ children, className, uid, swatch }) => {
  const classNameRoot = classNames(
    'LegendItem',
    `LegendItem--${uid}`,
    className,
  );
  const styleSwatch = { backgroundColor: swatch };
  return (
    <li className={classNameRoot}>
      <span className="LegendItem__swatch" style={styleSwatch} />
      <span className="LegendItem__content">
        {children}
      </span>
    </li>
  );
};

LegendItem.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  uid: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  swatch: PropTypes.string,
};

LegendItem.defaultProps = {
  className: null,
  swatch: null,
};

export default LegendItem;



// WEBPACK FOOTER //
// ./src/components/Chart/Legend/LegendItem/index.js